/* Nuvelia — global.js */
(function () {
  'use strict';

  var moneyFormat = window.themeMoneyFormat || '${{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount);
  }

  function merchandiseSubtotal(cart) {
    var subtotal = Number(cart.items_subtotal_price);
    if (!Number.isFinite(subtotal)) {
      subtotal = (cart.items || []).reduce(function (sum, item) {
        return sum + Number(item.final_line_price || 0);
      }, 0);
    }
    var discounts = (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
      return sum + (discount.target_type === 'shipping_line' ? 0 : Number(discount.total_allocated_amount || 0));
    }, 0);
    return Math.max(0, subtotal - discounts);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function readCartResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
      return data;
    });
  }

  function showCartError(message) {
    var error = document.querySelector('[data-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('data-cart-error', '');
      error.setAttribute('role', 'alert');
      var parent = document.querySelector('[data-cart-items]');
      if (parent) parent.before(error);
    }
    error.textContent = message;
  }

  /* ---------- Mobile menu ---------- */
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileClose = document.querySelector('[data-mobile-menu-close]');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('is-open');
  }
  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
  }
  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.getAttribute('data-cart-trigger') === 'link') return;
      e.preventDefault();
      openCartDrawer();
    });
  });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  /* ---------- Refresh cart drawer contents via Ajax API ---------- */
  function renderCartDrawer(cart) {
    var itemsEl = document.querySelector('[data-cart-items]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var emptyEl = document.querySelector('[data-cart-empty]');
    var footerEl = document.querySelector('[data-cart-footer]');
    var crossSellEl = document.querySelector('[data-cart-cross-sell]');

    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (subtotalEl) subtotalEl.textContent = formatMoney(merchandiseSubtotal(cart));

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
      if (crossSellEl) crossSellEl.style.display = 'none';
      updateFreeShippingBar(cart);
      updateGiftProgress(cart);
      updateOrderBump(cart);
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (crossSellEl) crossSellEl.style.display = 'block';

    itemsEl.innerHTML = cart.items.map(function (item) {
      return (
        '<div class="cart-item" data-line-key="' + item.key + '">' +
          '<div class="cart-item__image">' + (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') + '</div>' +
          '<div class="cart-item__body">' +
            '<p class="cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
            (item.variant_title ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<div class="cart-item__controls">' +
              '<div class="qty-selector">' +
                '<button type="button" data-qty-decrease>&minus;</button>' +
                '<input type="number" min="0" value="' + item.quantity + '" data-qty-input data-line-key="' + item.key + '">' +
                '<button type="button" data-qty-increase>+</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-cart-remove data-line-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
          '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
        '</div>'
      );
    }).join('');

    updateFreeShippingBar(cart);
    updateGiftProgress(cart);
    updateOrderBump(cart);
  }

  function updateFreeShippingBar(cart) {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;
    var threshold = parseFloat(bar.getAttribute('data-threshold')) * 100;
    var fill = bar.querySelector('[data-free-shipping-fill]');
    var text = bar.querySelector('[data-free-shipping-text]');
    var subtotal = merchandiseSubtotal(cart);
    var remaining = threshold - subtotal;
    var pct = Math.min(100, (subtotal / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      text.textContent = remaining <= 0
        ? (bar.getAttribute('data-msg-reached') || 'You unlocked free shipping!')
        : (bar.getAttribute('data-msg-remaining') || '').replace(/\{\{\s*amount\s*\}\}/, formatMoney(remaining));
    }
  }

  function cartHasVariant(cart, variantId) {
    return cart.items.some(function (item) { return String(item.variant_id) === String(variantId); });
  }

  function updateGiftProgress(cart) {
    var giftWrap = document.querySelector('[data-cart-gift]');
    if (!giftWrap) return;
    giftWrap.style.display = cart.item_count === 0 ? 'none' : '';
    document.querySelectorAll('[data-gift-tier]').forEach(function (tierEl) {
      var threshold = parseInt(tierEl.getAttribute('data-gift-threshold'), 10);
      var variantId = tierEl.getAttribute('data-variant-id');
      var messageEl = tierEl.querySelector('[data-gift-message]');
      var remainingEl = tierEl.querySelector('[data-gift-remaining]');
      var claimBtn = tierEl.querySelector('[data-gift-claim]');
      var alreadyClaimed = cartHasVariant(cart, variantId);

      if (alreadyClaimed) {
        if (messageEl) messageEl.style.display = 'none';
        if (claimBtn) claimBtn.style.display = 'none';
        tierEl.classList.add('is-claimed');
        return;
      }
      tierEl.classList.remove('is-claimed');

      if (merchandiseSubtotal(cart) >= threshold) {
        if (messageEl) messageEl.style.display = 'none';
        if (claimBtn) claimBtn.style.display = 'flex';
      } else {
        if (messageEl) messageEl.style.display = 'block';
        if (claimBtn) claimBtn.style.display = 'none';
        if (remainingEl) remainingEl.textContent = formatMoney(threshold - merchandiseSubtotal(cart));
      }
    });
  }

  function updateOrderBump(cart) {
    var bump = document.querySelector('[data-order-bump]');
    if (!bump) return;
    var variantId = bump.getAttribute('data-variant-id');
    bump.style.display = cartHasVariant(cart, variantId) ? 'none' : 'flex';
  }

  var cartUpdating = false;
  function updateLineQuantity(key, quantity) {
    if (!key || cartUpdating) return;
    cartUpdating = true;
    var controls = document.querySelectorAll('[data-cart-items] button, [data-cart-items] input, [data-cart-page] button, [data-cart-page] input');
    controls.forEach(function (control) { control.disabled = true; });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(readCartResponse)
      .then(function () { return fetch('/cart.js', { cache: 'no-store' }).then(readCartResponse); })
      .then(function (cart) {
        showCartError('');
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        renderCartDrawer(cart);
      })
      .catch(function (err) { showCartError(err.message); })
      .finally(function () {
        cartUpdating = false;
        controls.forEach(function (control) { control.disabled = false; });
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-increase], [data-qty-decrease], [data-cart-remove]');
    if (!button || !button.closest('[data-cart-items], [data-cart-page]')) return;
    if (button.hasAttribute('data-cart-remove')) {
      updateLineQuantity(button.getAttribute('data-line-key'), 0);
      return;
    }
    var input = button.parentElement.querySelector('[data-qty-input]');
    if (!input) return;
    var delta = button.hasAttribute('data-qty-increase') ? 1 : -1;
    updateLineQuantity(input.getAttribute('data-line-key'), Math.max(0, (Number(input.value) || 0) + delta));
  });
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input][data-line-key]');
    if (!input || !input.closest('[data-cart-items], [data-cart-page]')) return;
    updateLineQuantity(input.getAttribute('data-line-key'), Math.max(0, Math.floor(Number(input.value) || 0)));
  });

  /* ---------- Add to cart (product form) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var quantityInput = form.querySelector('[data-qty-input]');
    function syncQuantity() {
      if (!quantityInput) return;
      var quantity = Math.max(1, Math.floor(Number(quantityInput.value) || 1));
      quantityInput.value = quantity;
      var pack = form.querySelector('[data-pack-qty="' + quantity + '"]');
      if (pack) { pack.click(); return; }
      form.querySelectorAll('[data-pack-qty]').forEach(function (option) { option.classList.remove('is-selected'); });
      var single = form.querySelector('[data-pack-qty="1"]');
      if (single) {
        var unitPrice = Number(single.getAttribute('data-pack-price'));
        var price = form.closest('.product-info').querySelector('[data-product-price]');
        var stickyPrice = document.querySelector('[data-mobile-sticky-price]');
        var label = formatMoney(unitPrice) + ' each';
        if (price) price.textContent = label;
        if (stickyPrice) stickyPrice.textContent = label;
      }
    }
    if (quantityInput) {
      form.querySelector('[data-qty-increase]').addEventListener('click', function () { quantityInput.value = (Number(quantityInput.value) || 1) + 1; syncQuantity(); });
      form.querySelector('[data-qty-decrease]').addEventListener('click', function () { quantityInput.value = Math.max(1, (Number(quantityInput.value) || 1) - 1); syncQuantity(); });
      quantityInput.addEventListener('change', syncQuantity);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var error = form.querySelector('[data-product-error]');
      if (error) error.textContent = '';
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(readCartResponse)
        .then(function () {
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          renderCartDrawer(cart);
          openCartDrawer();
        })
        .catch(function (err) {
          if (!error) { error = document.createElement('p'); error.setAttribute('data-product-error', ''); error.setAttribute('role', 'alert'); form.appendChild(error); }
          error.textContent = err.message;
        })
        .finally(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  });

  /* ---------- Cart cross-sell quick add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cross-sell-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js').then(function (res) { return res.json(); }); })
      .then(function (cart) {
        renderCartDrawer(cart);
        openCartDrawer();
      })
      .catch(function (err) { console.error('Cross-sell add failed', err); })
      .finally(function () { btn.disabled = false; });
  });

  /* ---------- Free gift claim ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gift-claim]');
    if (!btn) return;
    var tierEl = btn.closest('[data-gift-tier]');
    var variantId = tierEl.getAttribute('data-variant-id');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js').then(function (res) { return res.json(); }); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function (err) { console.error('Gift claim failed', err); })
      .finally(function () { btn.disabled = false; });
  });

  /* ---------- Cart order bump ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-order-bump-add]');
    if (!btn) return;
    var bump = btn.closest('[data-order-bump]');
    var variantId = bump.getAttribute('data-variant-id');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js').then(function (res) { return res.json(); }); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function (err) { console.error('Order bump add failed', err); })
      .finally(function () { btn.disabled = false; });
  });

  /* ---------- Sync cart-dependent UI with current cart on page load ---------- */
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateFreeShippingBar(cart);
      updateGiftProgress(cart);
      updateOrderBump(cart);
    })
    .catch(function () {});

  /* ---------- Register explicit privacy choices with Shopify ---------- */
  (function () {
    var banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    var buttons = banner.querySelectorAll('button');
    var error = banner.querySelector('[data-consent-error]');
    function syncConsentSpace() {
      var height = banner.classList.contains('is-visible') ? Math.ceil(banner.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--cookie-banner-height', height + 'px');
    }
    if (window.ResizeObserver) new ResizeObserver(syncConsentSpace).observe(banner);
    window.addEventListener('resize', syncConsentSpace);
    function showError() {
      if (error) error.textContent = 'Your choice could not be saved. Please try again or use Your Privacy Choices.';
      banner.classList.add('is-visible');
      syncConsentSpace();
    }
    function withPrivacy(callback) {
      if (window.Shopify && window.Shopify.customerPrivacy) { callback(window.Shopify.customerPrivacy); return; }
      if (!window.Shopify || !window.Shopify.loadFeatures) { showError(); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (failure) {
        if (failure || !window.Shopify.customerPrivacy) { showError(); return; }
        callback(window.Shopify.customerPrivacy);
      });
    }
    function saveChoice(accepted) {
      withPrivacy(function (privacy) {
        buttons.forEach(function (button) { button.disabled = true; });
        if (error) error.textContent = '';
        var timeout = setTimeout(function () {
          buttons.forEach(function (button) { button.disabled = false; });
          showError();
        }, 10000);
        try {
          privacy.setTrackingConsent({ analytics: accepted, marketing: accepted, preferences: accepted }, function () {
            clearTimeout(timeout);
            buttons.forEach(function (button) { button.disabled = false; });
            var consent = privacy.currentVisitorConsent();
            var expected = accepted ? 'yes' : 'no';
            if (consent.analytics !== expected || consent.marketing !== expected) { showError(); return; }
            banner.classList.remove('is-visible');
            syncConsentSpace();
            window.dispatchEvent(new Event('resize'));
          });
        } catch (failure) {
          clearTimeout(timeout);
          buttons.forEach(function (button) { button.disabled = false; });
          showError();
        }
      });
    }
    var accept = banner.querySelector('[data-cookie-accept]');
    var decline = banner.querySelector('[data-cookie-decline]');
    document.querySelectorAll('[data-cookie-settings]').forEach(function (button) {
      button.addEventListener('click', function () {
        banner.classList.add('is-visible');
        syncConsentSpace();
        if (decline) decline.focus();
      });
    });
    if (accept) accept.addEventListener('click', function () { saveChoice(true); });
    if (decline) decline.addEventListener('click', function () { saveChoice(false); });
    withPrivacy(function (privacy) {
      var consent = privacy.currentVisitorConsent();
      var hasChoice = consent.analytics !== '' && consent.marketing !== '';
      if (!hasChoice) banner.classList.add('is-visible');
      syncConsentSpace();
    });
  })();

  /* ---------- Mobile sticky add-to-cart bar ---------- */
  (function () {
    var buyBox = document.querySelector('[data-buy-box]');
    var stickyBar = document.querySelector('[data-mobile-sticky-bar]');
    var stickyCta = document.querySelector('[data-mobile-sticky-cta]');
    if (!buyBox || !stickyBar) return;

    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        var realBtn = document.querySelector('[data-add-to-cart-btn]');
        if (realBtn) realBtn.click();
      });
    }

    var ticking = false;
    function updateStickyBar() {
      ticking = false;
      var cookieBanner = document.querySelector('[data-cookie-banner].is-visible');
      if (cookieBanner) {
        stickyBar.classList.remove('is-visible');
        return;
      }
      var rect = buyBox.getBoundingClientRect();
      var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      stickyBar.classList.toggle('is-visible', outOfView);
    }
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateStickyBar);
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    updateStickyBar();
  })();

  /* ---------- Product gallery (swipeable, one slide at a time) ---------- */
  (function () {
    var track = document.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.from(track.querySelectorAll('[data-gallery-slide]'));
    var dots = Array.from(document.querySelectorAll('[data-gallery-dot]'));
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (!slides.length) return;

    var currentIndex = 0;

    function setActiveDot(index) {
      currentIndex = index;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    function goToIndex(index, instant) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActiveDot(index);
    }

    function goToImageId(imageId, instant) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-image-id') === String(imageId); });
      if (idx !== -1) goToIndex(idx, instant);
    }
    window.nuveliaGalleryGoToImage = goToImageId;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goToIndex(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goToIndex(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToIndex(currentIndex + 1); });

    var ticking = false;
    function updateActiveFromScroll() {
      ticking = false;
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      if (idx !== currentIndex) setActiveDot(idx);
    }
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActiveFromScroll);
    }, { passive: true });
  })();

  /* ---------- Pack selector ---------- */
  document.querySelectorAll('[data-pack-selector]').forEach(function (selector) {
    var options = selector.querySelectorAll('[data-pack-qty]');
    var form = selector.closest('form');
    var qtyInput = form ? form.querySelector('[data-qty-input]') : null;
    var priceEl = form && form.closest('.product-info') && form.closest('.product-info').querySelector('[data-product-price]');
    var stickyPriceEl = document.querySelector('[data-mobile-sticky-price]');
    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (qtyInput) qtyInput.value = btn.getAttribute('data-pack-qty');

        var packPrice = parseInt(btn.getAttribute('data-pack-price'), 10);
        var packCompare = parseInt(btn.getAttribute('data-pack-compare'), 10);
        if (priceEl && !isNaN(packPrice)) {
          if (packCompare && packCompare > packPrice) {
            priceEl.innerHTML =
              '<span class="price--sale">' + formatMoney(packPrice) + '</span>' +
              '<span class="price--compare">' + formatMoney(packCompare) + '</span>';
          } else {
            priceEl.textContent = formatMoney(packPrice);
          }
        }
        if (stickyPriceEl && !isNaN(packPrice)) stickyPriceEl.textContent = formatMoney(packPrice);

        var packImageId = btn.getAttribute('data-pack-image-id');
        if (packImageId && window.nuveliaGalleryGoToImage) {
          window.nuveliaGalleryGoToImage(packImageId);
        }
      });
    });
  });

  /* ---------- Accordion (product info) ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      trigger.closest('[data-accordion-item]').classList.toggle('is-open');
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var productData;
    try {
      productData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    var variants = productData.variants;
    var picker = form.querySelector('[data-variant-picker]');
    var idInput = form.querySelector('[data-selected-variant-id]');
    var priceEl = form.closest('.product-info') && form.closest('.product-info').querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');
    var stickyPriceEl = document.querySelector('[data-mobile-sticky-price]');
    var stickyCtaEl = document.querySelector('[data-mobile-sticky-cta]');

    function currentSelection() {
      var selected = [];
      if (!picker) return selected;
      picker.querySelectorAll('[data-swatch-group]').forEach(function (group) {
        var active = group.querySelector('.swatch.is-selected');
        var position = parseInt(group.getAttribute('data-option-position'), 10);
        selected[position - 1] = active ? active.getAttribute('data-value') : null;
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      return variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function formatMoneyLocal(cents) {
      return formatMoney(cents);
    }

    function updateForSelection() {
      var selected = currentSelection();
      var variant = findMatchingVariant(selected);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (idInput) idInput.value = '';
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (variant.featured_image && window.nuveliaGalleryGoToImage) {
        window.nuveliaGalleryGoToImage(variant.featured_image.id);
      }

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="price--sale">' + formatMoneyLocal(variant.price) + '</span>' +
            '<span class="price--compare">' + formatMoneyLocal(variant.compare_at_price) + '</span>';
        } else {
          priceEl.textContent = formatMoneyLocal(variant.price);
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (stickyPriceEl) stickyPriceEl.textContent = formatMoneyLocal(variant.price);
      if (stickyCtaEl) {
        stickyCtaEl.disabled = !variant.available;
        stickyCtaEl.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (picker) {
        picker.querySelectorAll('[data-swatch-group]').forEach(function (group) {
          var position = parseInt(group.getAttribute('data-option-position'), 10);
          group.querySelectorAll('[data-swatch]').forEach(function (s) {
            var testSelection = selected.slice();
            testSelection[position - 1] = s.getAttribute('data-value');
            var match = findMatchingVariant(testSelection);
            s.disabled = !match || !match.available;
          });
        });
      }
    }

    if (picker) {
      picker.querySelectorAll('[data-swatch]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var group = swatch.closest('[data-swatch-group]');
          group.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
          swatch.classList.add('is-selected');
          updateForSelection();
        });
      });
    }

    var skipInitialImage = picker && picker.hasAttribute('data-skip-initial-image');
    if (variants.length > 1 && !skipInitialImage) {
      var initialVariant = variants.find(function (v) { return v.id === productData.selectedVariantId; });
      if (initialVariant && initialVariant.featured_image && window.nuveliaGalleryGoToImage) {
        window.nuveliaGalleryGoToImage(initialVariant.featured_image.id, true);
      }
    }
  });

  /* ---------- Newsletter form feedback ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var msg = form.getAttribute('data-success-message');
      if (msg) {
        setTimeout(function () {
          var note = form.querySelector('[data-newsletter-success]');
          if (note) note.style.display = 'block';
        }, 100);
      }
    });
  });
})();
